module.exports = __webpack_public_path__ + "img/patacones_rellenos_de_camaraones.3b0b2f70.jpg";